import React from "react";
import { Search } from "lucide-react";

export default function ModulePersonalNotesSearch({ value, onChange }) {
    return (
        <div className="mpn-search">
            <Search size={16} />
            <input
                value={value}
                onChange={(event) => onChange?.(event.target.value)}
                placeholder="Rechercher dans mes notes"
            />
        </div>
    );
}
